import { createApp } from 'vue'
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { createPinia } from 'pinia';
import router from './router';
import i18n from './plugins/i18n';
import { CegatKeycloak, AuthenticationPlugin } from './plugins/authentication';
import 'vuetify/styles'
import './scss/index.scss';
import { PermissionsService } from '@/services/permissions.service';
import { LoggingService } from '@/services/logging.service';
import guardFactory from '@/router/roleguard';

const logService = new LoggingService();

function injectScripts() {
  const externalScript = document.createElement('script');
  externalScript.src = '/iframeResizer.contentWindow.min.js';

  const internalScript = document.createElement('script');
  internalScript.innerHTML = `window.iFrameResizer = { targetOrigin: '${window.location.origin}' }`;

  document.body.appendChild(internalScript);
  document.body.appendChild(externalScript);
}

function configureApp(app: ReturnType<typeof createApp>) {
  const permissionsService = new PermissionsService(CegatKeycloak);

  if (import.meta.env.DEV) {
    app.config.performance = true;
  }

  app.config.errorHandler = (err: unknown, instance, info) => {
    const error = err instanceof Error ? err : new Error(String(err));
    const message = `Error: ${error.message}; At ${info} - ${(instance?.$options as any)?._componentTag}; ${error.stack}`;
    logService.postLog({ logLevel: "error", message });
  };

  app.config.globalProperties.$keycloak = CegatKeycloak;

  // Object.defineProperty(app.config.globalProperties, 'user', {
  //   get() {
  //     const tokenParsed = (this as any).$keycloak.tokenParsed;
  //     return tokenParsed ? new AuthenticatedUser(tokenParsed) : null;
  //   }
  // });

  Object.defineProperty(app.config.globalProperties, 'backend_token', {
    value: null,
    writable: true,
  });

  router.beforeEach(guardFactory(router, CegatKeycloak));

  app
    .use(createPinia())
    .use(router)
    .use(vuetify)
    .use(i18n)
    .use(AuthenticationPlugin)
    .provide('permissions', permissionsService);
}

async function bootstrap() {
  try {
    injectScripts();

    await CegatKeycloak.init({
      onLoad: 'login-required',
      enableLogging: true,
    });

    const app = createApp(App);
    configureApp(app);

    app.mount('#app');
  } catch (error) {
    console.error('App initialization failed:', error);
  }
}

// rewrite old hash URLs
const hash = window.location.hash
if (hash.startsWith('#/')) {
  window.location.replace(hash.substring(1))
}

bootstrap();
